import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';

export default function OdemeBasarili() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  const amount = searchParams.get('amount');

  return (
    <section className="py-5" style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', marginTop: '80px' }}>
      <div className="container text-center">
        <h2 className="mb-3">Ödeme Başarılı</h2>
        <p className="text-success mb-2">Kart ödemeniz alındı.</p>
        {orderId && <p className="small text-muted">Sipariş no: {orderId}</p>}
        {amount && <p className="small text-muted">Tutar: {amount} TL</p>}
        <Link to="/" className="btn btn-primary mt-3">Ana Sayfaya Dön</Link>
      </div>
    </section>
  );
}
